<template>
    <v-row>
        <v-col cols="12" class="mt-2 d-flex flex-wrap dashboard-links">
            <a class="link" href="https://myschng.tawk.help/article/how-to-use-the-myschng-students-results-portal" target="_blank">
                <v-icon small left color="primary">mdi-play-circle-outline</v-icon>
                Watch how the software works
            </a>
            <a class="link" href="https://myschng.tawk.help/article/how-tokens-work-on-mysch-results-portal" target="_blank">
                <v-icon small left color="primary">mdi-information-outline</v-icon>
                Learn about Tokens
            </a>
            <a class="link" @click="buyTokenModal = !buyTokenModal">
                <v-icon small left color="primary">mdi-shopping-outline</v-icon>
                Buy More Tokens
            </a>
        </v-col>

        <buy-token-modal v-if="buyTokenModal"/>
    </v-row>
</template>
<script>
import BuyTokenModal from '../components/BuyTokenModal.vue';
  export default {
    name: 'CommonDashInfo',
    components: {
        BuyTokenModal
    },
    data: () => ({
        buyTokenModal: false,
    }),
  }
</script>

<style scoped>
.dashboard-links {
    gap: 24px;
}
.link{
    text-decoration: none;
    font-weight: 600;
    font-size: 0.85rem;
    color: #1E3C72;
    display: inline-flex;
    align-items: center;
}
</style>
